import { useQuery } from "@tanstack/react-query";
import { getMyAgentPage } from "@/services/gitchaReachService";

export const MY_GITCHA_REACH_KEY = ["myGitchaReach"];

const useMyGitchaReach = (enabled = true) =>
  useQuery({
    queryKey: MY_GITCHA_REACH_KEY,
    queryFn: async () => {
      const response = await getMyAgentPage();
      if (response?.errorCode !== 0) throw new Error(response?.message || "Could not load your Gitcha bio.");
      return response.result || null;
    },
    enabled,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });

export default useMyGitchaReach;
